import { CASE_STATUS_START, CASE_STATUS_RESERVE, CASE_STATUS_CANCEL, CASE_STATUS_RESIGN, CASE_STATUS_INVALID, CASE_STATUS_INVALID_STRING, CASE_STATUS_RESIGN_STRING, CASE_STATUS_CANCEL_STRING, CASE_STATUS_RESERVE_STRING, CASE_STATUS_ONBOARD_STRING, CASE_STATUS_ONBOARD } from "./ItemRecruitmentContractor"
import moment from "moment"

export class ReqRecruitmentContractorStatusList {
    constructor({ companyId, start, limit, name, address, contractorJobStatus, job, office, skill, isPublic = true }) {
        this.companyId = companyId
        this.start = start
        this.limit = limit
        if (name !== undefined && name !== "") {
            this.name = name
        }
        if (address !== undefined && address !== "") {
            this.address = address
        }
        if (contractorJobStatus !== undefined && contractorJobStatus !== "") {
            this.contractorJobStatus = contractorJobStatus
        }
        if (job !== undefined && job !== "") {
            this.job = job
        }
        if (office !== undefined && office !== "") {
            this.office = office
        }
        if (skill !== undefined && skill !== "") {
            this.skill = skill
        }
        this.isPublic = isPublic
    }

    fromJson(jsonData) {
        if (jsonData.name !== undefined)
            this.name = jsonData.name
        if (jsonData.address !== undefined)
            this.address = jsonData.address
        if (jsonData.contractorJobStatus !== undefined)
            this.contractorJobStatus = jsonData.contractorJobStatus
        if (jsonData.job !== undefined)
            this.job = jsonData.job
        if (jsonData.office !== undefined)
            this.office = jsonData.office
        if (jsonData.skill !== undefined)
            this.skill = jsonData.skill
    }
}

export class ReqPositionDemandDetail {
    constructor({ customerContractId, customerPositionId }) {
        this.customerContractId = customerContractId
        this.customerPositionId = customerPositionId
    }
}

export class ReqRecruitmentContractorStatusDetail {
    constructor({ caseContractor }) {
        this.caseContractor = caseContractor
    }
    fromJson(jsonData) {
        this.caseContractor = jsonData.caseContractor || ""
    }
}

export class ReqRecruitmentContractorStatusProcessList {
    constructor({ caseContractor, start, limit }) {
        this.caseContractor = caseContractor
        this.start = start
        this.limit = limit
    }
    fromJson(jsonData) {
        if (jsonData.start !== undefined)
            this.start = jsonData.start
        if (jsonData.limit !== undefined)
            this.limit = jsonData.limit
    }
}

export function getCaseStatusString(item, caseInfo) {
    var str = getCaseStatus(item, caseInfo)
    switch (item.caseStatus) {
        case CASE_STATUS_START:
        case CASE_STATUS_RESERVE:
            return str.status
        default:
            return str.status + " " + str.statusDeta
    }

}
export function getCaseStatus(item, caseInfo) {

    switch (item.caseStatus) {
        case CASE_STATUS_START:
            return {
                companyName: "--",
                jobInfo: "--",
                statusDeta: moment(item.creatAt).format('YYYY/MM/DD'),
                status: "新人"
            }
        case CASE_STATUS_RESERVE:
            return {
                statusDeta: moment(caseInfo.caseReserveDate).format('YYYY/MM/DD'),
                status: CASE_STATUS_RESERVE_STRING
            }
        case CASE_STATUS_ONBOARD:
            console.log(caseInfo.caseOnBoardDate)
            return {
                statusDeta: moment(caseInfo.caseOnBoardDate).format('YYYY/MM/DD'),
                status: CASE_STATUS_ONBOARD_STRING
            }
        case CASE_STATUS_CANCEL:
            return {
                statusDeta: moment(caseInfo.caseCancelDate).format('YYYY/MM/DD'),
                status: CASE_STATUS_CANCEL_STRING
            }
        case CASE_STATUS_RESIGN:
            return {
                statusDeta: moment(caseInfo.caseResignDate).format('YYYY/MM/DD'),
                status: CASE_STATUS_RESIGN_STRING
            }
        case CASE_STATUS_INVALID:
            return {
                statusDeta: moment(caseInfo.caseInvalidDate).format('YYYY/MM/DD'),
                status: CASE_STATUS_INVALID_STRING
            }
        default:
            console.log(item)
            return {
                statusDeta: item.caseStatus,
                status: ""
            }
    }
}

export function getCaseStatus_String(caseStatus) {

    switch (caseStatus) {
        case CASE_STATUS_START:
            return "新人"
        case CASE_STATUS_RESERVE:
            return CASE_STATUS_RESERVE_STRING
        case CASE_STATUS_ONBOARD:
            return CASE_STATUS_ONBOARD_STRING
        case CASE_STATUS_CANCEL:
            return CASE_STATUS_CANCEL_STRING
        case CASE_STATUS_RESIGN:
            return CASE_STATUS_RESIGN_STRING
        case CASE_STATUS_INVALID:
            return CASE_STATUS_INVALID_STRING
        default:
            return ""
    }
}